import { mapActions } from 'vuex'

export default {
  data() {
    return {
      mainInfo: {},
    }
  },
  computed: {
    orgId() {
      return this.$route.query.orgId
    },
  },
  methods: {
    ...mapActions('user', ['getUserInfo']),
    async setMainInfo() {
      try {
        const personInfo = await this.getUserInfo()
        if (this.orgId) {
          this.mainInfo = await this.getOrgInfo()
        } else {
          this.mainInfo = personInfo
          this.mainInfo.ouid = 'sys_org_id'
          this.mainInfo.guid = this.mainInfo.base.guid
          this.mainInfo.realnameStatus = this.mainInfo.baseRealname.status
          console.log(this.mainInfo)
        }
      } catch (e) {
        console.error(e)
        this.mainInfo = {}
      }

      return this.mainInfo
    },
    async getOrgInfo() {
      const { data } = await this.$EHttp.api({
        url: `webserver/v1/organizations/${this.orgId}/getDecorationInfo`,
        method: 'get',
      })

      return {
        name: data.prop.properties.name || '',
        realnameStatus: !!data.baseRealname.status,
        guid: data.base.guid,
        ouid: data.base.ouid,
      }
    },
  },
}
